import { render, staticRenderFns } from "./notAction.vue?vue&type=template&id=b72ca36e&"
import script from "./notAction.vue?vue&type=script&lang=js&"
export * from "./notAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports